/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
		  $(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  $(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$('.hamburger').click(function() {
		$(this).toggleClass('is-active');
		$('body').toggleClass('mobile-nav-open');
	});

	var pageCover = $('.entry-content > .wp-block-cover:first-child.is-style-landing');

	if (pageCover.length > 0) {
		$('.masthead').addClass('transparent initialized');
	}
	else {
		$('.masthead').addClass('initialized');
	}

	$('.cfm-episode-link a').text('read more');
	$('.cap-links-wrap').insertBefore('.article-header');

});
